// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8f7a7fcf","239":"5491b2ce","732":"a38800b4"}[chunkId] + ".chunk.js";
};